import React from "react";

const SlidingNotice = () => {
  return (
    <div className="w-full bg-[#0b3d0b] text-white py-2 overflow-hidden relative mt-4">
      <div className="whitespace-nowrap animate-slide hover:[animation-play-state:paused]">
        <span className="mx-4 text-base">
          In case of queries, Please Call{" "}
          <a
            href="tel:+919773571992"
            className="text-yellow-300 font-semibold hover:underline"
          >
            Divya Singh
          </a>
        </span>
      </div>
      <style>
        {`
          @keyframes slide {
            0% { transform: translateX(100%); }
            100% { transform: translateX(-100%); }
          }
          .animate-slide {
            display: inline-block;
            animation: slide 12s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default SlidingNotice;
